// Theme application for the console. Dark is the default (matches the design brief + the
// secops :root tokens); a `.theme-light` class on <html> flips to the light token set. Brand
// (data-brand) defaults to secops; per-account branding (account_brand_profiles) wires later.

const THEME_KEY = "secops.console.theme";

export type ConsoleTheme = "light" | "dark";

/** Apply the persisted theme on boot (call before first render to avoid a flash). */
export function applyStoredTheme(): void {
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    document.documentElement.classList.toggle("theme-light", stored === "light");
  } catch {
    // Storage unavailable — keep the dark default.
  }
}

export function currentTheme(): ConsoleTheme {
  return document.documentElement.classList.contains("theme-light") ? "light" : "dark";
}

export function setTheme(theme: ConsoleTheme): void {
  document.documentElement.classList.toggle("theme-light", theme === "light");
  try {
    window.localStorage.setItem(THEME_KEY, theme);
  } catch {
    // Ignore — the class change still applies for this session.
  }
}
